import { useState } from "react";
import { X } from "lucide-react";
import { useSite } from "../lib/SiteContext";
import { optImg } from "../lib/image";
import Seo from "../components/Seo";
import FadeIn from "../components/FadeIn";

const Gallery = () => {
  const { content } = useSite();
  const [active, setActive] = useState(null);
  const images = content?.gallery || [];

  return (
    <div data-testid="gallery-page">
      <Seo
        title="Corfu Photo Gallery — Aloha Corfu Tours"
        description="Beaches, villages, sunsets and hidden corners of Corfu — a gallery of the island we love to share on our private tours."
      />
      <section className="bg-pine-dark py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-seafoam">The island, in frames</p>
            <h1 className="mt-2 font-display text-4xl font-semibold text-white sm:text-5xl">Corfu Gallery</h1>
            <p className="mt-4 max-w-2xl text-base text-white/75">A glimpse of the places we visit on our private tours around Corfu.</p>
          </FadeIn>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4" data-testid="gallery-grid">
            {images.map((src, i) => (
              <FadeIn key={src} delay={Math.min(i, 6) * 0.05}>
                <button
                  onClick={() => setActive(src)}
                  data-testid={`gallery-image-${i}`}
                  className="block w-full overflow-hidden rounded-2xl shadow-soft transition-transform duration-300 hover:scale-[1.02]"
                >
                  <img src={optImg(src, 700)} alt={`Corfu, Greece — gallery photo ${i + 1} from Aloha Corfu Tours`}
                       loading="lazy" decoding="async" className="aspect-square w-full object-cover" />
                </button>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-aegean/90 p-4 backdrop-blur"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <button className="absolute right-5 top-5 rounded-full bg-white/10 p-2 text-white transition-colors hover:bg-white/20"
                  aria-label="Close" data-testid="gallery-lightbox-close">
            <X className="h-6 w-6" />
          </button>
          <img src={optImg(active, 1600, 85)} alt="Corfu, Greece — enlarged gallery photo" className="max-h-[85vh] max-w-full rounded-2xl object-contain" />
        </div>
      )}
    </div>
  );
};

export default Gallery;
